import React from "react";

import ContentLoader from "react-content-loader";

const EventDetailLoading = (props) => (
  <div className="h-full px-2 sm:px-14 lg:px-2">
    <ContentLoader
      viewBox="0 0 300 460"
      {...props}
      backgroundColor="#f5f5f5"
      foregroundColor="#ebebeb"
    >
      <rect x="0" y="0" rx="8" ry="8" width="300" height="180" />
      <rect x="0" y="190" rx="4" ry="4" width="292" height="20" />
      <rect x="0" y="215" rx="4" ry="4" width="239" height="20" />
      <rect x="0" y="242" rx="4" ry="4" width="274" height="20" />
    </ContentLoader>
  </div>
);

export default EventDetailLoading;
